export default "__VITE_ASSET__I$Eu5dlZ__"